import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './partials/footer';
import Menu from './partials/menu';
import Navbar from './partials/navbar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LayoutProvider, useLayout } from './LayoutContext';
import './responsive-layout.css'; // on le crée en étape 5

const LayoutShell = () => {
  const { sidebarOpen, isXLUp, closeSidebar } = useLayout();

  return (
    <>
      <ToastContainer />
      <div className={`layout-wrapper layout-content-navbar ${sidebarOpen ? 'has-sidebar-open' : ''}`}>
        <div className="layout-container">
          {/* Menu */}
          <Menu />
          {/* / Menu */}

          {/* Layout container */}
          <div className="layout-page">
            {/* Navbar */}
            <Navbar />
            {/* / Navbar */}

            {/* Content wrapper */}
            <div className="content-wrapper">
              {/* Content */}
              <Outlet />
              {/* / Content */}
              {/* Footer */}
              <Footer />
              {/* / Footer */}
              <div className="content-backdrop fade" />
            </div>
            {/* Content wrapper */}
          </div>
          {/* / Layout page */}
        </div>

        {/* Overlay (mobile uniquement) */}
        {!isXLUp && sidebarOpen && (
          <div className="layout-overlay layout-menu-toggle show" onClick={closeSidebar} />
        )}
      </div>
    </>
  );
};

const MainLayout = () => (
  <LayoutProvider>
    <LayoutShell />
  </LayoutProvider>
);

export default MainLayout;
